import type { Framework } from '@toeverything/infra';

import { WorkspaceServerService } from '../cloud';
import { CacheStorage } from '../storage';
import { WorkspaceScope, WorkspaceService } from '../workspace';
import { WorkspaceLocalCacheService } from './workspace-local-cache';

export * from './use-workspace-local-cache';
export * from './workspace-local-cache';

export function configureWorkspaceLocalCacheModule(framework: Framework) {
  framework
    .scope(WorkspaceScope)
    .service(WorkspaceLocalCacheService, [
      WorkspaceService,
      WorkspaceServerService,
      CacheStorage,
    ]);
}
